import { TRootState } from 'src/store';
import { TagTypeStatus } from 'src/types';

export const tagTypeItem = (state: TRootState, tagTypeId: string) => {
  const { tagTypes } = state.tags;

  const tagType = tagTypes.find((tagType) => tagType.id === tagTypeId);

  const hasNoTags = tagType?.Tags && tagType.Tags.length === 0;

  const canActivateTagType = tagType?.Tags?.find(
    (tag) => tag.status === TagTypeStatus.LIVE,
  );

  return {
    hasNoTags,
    canActivateTagType,
  };
};
